import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent, IonSpinner } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { IDeviceTableNode } from '../../../../IDeviceTable';

@Component({
  selector: 'app-p00045-installation-parametrage-check-wifi',
  templateUrl: './p00045-installation-parametrage-check-wifi.component.html',
  styleUrls: ['./p00045-installation-parametrage-check-wifi.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    IonSpinner,
  ],
})
export class P00045InstallationParametrageCheckWIFIComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  getImageFromValueZB() {
    const value =
      (
        this.productClass!.getProductDeviceTableFromPool(
          this.pool!,
        ) as IDeviceTableNode
      ).qualityZB ?? 0;
    if (value >= 60) {
      return '/assets/ecosystem/images/products/P00045/signal-light-4.png';
    }
    if (value >= 30) {
      return '/assets/ecosystem/images/products/P00045/signal-light-3.png';
    }
    if (value >= 0) {
      return '/assets/ecosystem/images/products/P00045/signal-light-2.png';
    }

    return '/assets/ecosystem/images/products/P00045/signal-light-0.png';
  }

  getImageFromValueWifi(
    etatConnexionWifi: number,
    etatProcessusWifi: number,
    wifiQualite: number,
  ) {
    if (etatConnexionWifi === 0) {
      if (etatProcessusWifi === 0) {
        return '/assets/ecosystem/images/products/P00045/signal-light-0.png';
      }
      return '';
    } else {
      if (wifiQualite >= 60) {
        return '/assets/ecosystem/images/products/P00045/signal-light-4.png';
      }
      if (wifiQualite >= 30) {
        return '/assets/ecosystem/images/products/P00045/signal-light-3.png';
      }
      if (wifiQualite >= 0) {
        return '/assets/ecosystem/images/products/P00045/signal-light-2.png';
      }

      return '/assets/ecosystem/images/products/P00045/signal-light-0.png';
    }
  }

  getTextFromValueZB() {
    const value =
      (
        this.productClass!.getProductDeviceTableFromPool(
          this.pool!,
        ) as IDeviceTableNode
      ).qualityZB ?? 0;

    if (value >= 60) {
      return 'P00045.installation.link.signalradio.bon';
    }
    if (value >= 30) {
      return 'P00045.installation.link.signalradio.moyen';
    }
    if (value >= 0) {
      return 'P00045.installation.link.signalradio.faible';
    }

    return 'P00045.installation.link.signalradio.faible';
  }

  getTextFromValueWifi(
    etatConnexionWifi: number,
    etatProcessusWifi: number,
    wifiQualite: number,
  ) {
    if (etatConnexionWifi === 0) {
      if (etatProcessusWifi === 0) {
        return 'P00045.installation.link.signalwifi.connexion';
      }
      return 'P00045.installation.link.signalwifi.search';
    } else {
      if (wifiQualite >= 60) {
        return 'P00045.installation.link.signalwifi.bon';
      }
      if (wifiQualite >= 30) {
        return 'P00045.installation.link.signalwifi.moyen';
      }
      if (wifiQualite >= 0) {
        return 'P00045.installation.link.signalwifi.faible';
      }
    }
    return '';
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }
}
